/**
 * Wrapper for list-page quick filter rows — dropdowns portaled above tables.
 * Theme: PaceHRM DS surface / border.
 */
export default function ListFilterBar({ children, footer }) {
  return (
    <div className="bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl shadow-[var(--ds-shadow-card)] p-3 overflow-visible relative z-20">
      {children}
      {footer}
    </div>
  );
}
